const crumbs = {
  state: {
   parentRouter: '',
   childRouter: ''
  },
  getters: {

  },
  mutations: {
    getRouterTitle(state, data) {
      state.parentRouter = data.parentRouter;
      state.childRouter = data.childRouter;
    }
  },
  actions: {
   
  }
}

export default crumbs



// WEBPACK FOOTER //
// ./src/store/modules/crumbs.js